<template>
	<div
		:class="['c-brands-insight', { processing: processing === true }]"
		:data-brandid="brand.id"
	>
		<section>
			<header>
				<img :src="`${assetUrl}/${brand.logo}`" />
				<article>
					<h3>{{ brand.name }}</h3>

					<p>
						<span v-if="currentInsight"
							>{{ brand.category }} | Total ads: {{ lifetimeInsight.totalAds }},
							Active ads: {{ lifetimeInsight.activeAds }}</span
						>
					</p>
				</article>
			</header>
			<div class="c-brands-insight__control">
				<a
					v-if="fbadlibrarylink"
					:href="fbadlibrarylink"
					target="_blank"
					class="btn btn-icon btn-box btn-sm"
				>
					<svg
						xmlns="http://www.w3.org/2000/svg"
						viewBox="0 0 24 24"
						fill="none"
					>
						<path
							d="M10 5.5L10.7514 4.75837C13.0959 2.41387 16.8971 2.41388 19.2416 4.75837C21.5861 7.10287 21.5861 10.9041 19.2416 13.2486L18.5 14M5.5 10L4.75837 10.7514C2.41387 13.0959 2.41388 16.8971 4.75838 19.2416C7.10287 21.5861 10.9041 21.5861 13.2486 19.2416L14 18.5M10 14L14 10"
							stroke="currentColor"
							stroke-width="2"
							stroke-linecap="round"
							stroke-linejoin="round"
						/>
					</svg>
					<span> Facebook ad library page </span>
				</a>
				<button
					type="button"
					class="btn btn-box btn-icon btn-sm"
					@click="connectGuideOpen = true"
				>
					<svg
						xmlns="http://www.w3.org/2000/svg"
						viewBox="0 0 24 24"
						fill="none"
					>
						<path
							d="M6 5.5C6 5.22386 5.77614 5 5.5 5C5.22386 5 5 5.22386 5 5.5C5 6.48063 4.78279 7.0726 4.4277 7.4277C4.0726 7.78279 3.48063 8 2.5 8C2.22386 8 2 8.22386 2 8.5C2 8.77614 2.22386 9 2.5 9C3.48063 9 4.0726 9.21721 4.4277 9.5723C4.78279 9.9274 5 10.5194 5 11.5C5 11.7761 5.22386 12 5.5 12C5.77614 12 6 11.7761 6 11.5C6 10.5194 6.21721 9.9274 6.5723 9.5723C6.9274 9.21721 7.51937 9 8.5 9C8.77614 9 9 8.77614 9 8.5C9 8.22386 8.77614 8 8.5 8C7.51937 8 6.9274 7.78279 6.5723 7.4277C6.21721 7.0726 6 6.48063 6 5.5Z"
							fill="currentColor"
						/>
						<path
							d="M11 1.5C11 1.22386 10.7761 1 10.5 1C10.2239 1 10 1.22386 10 1.5C10 2.13341 9.85918 2.47538 9.66728 2.66728C9.47538 2.85918 9.13341 3 8.5 3C8.22386 3 8 3.22386 8 3.5C8 3.77614 8.22386 4 8.5 4C9.13341 4 9.47538 4.14082 9.66728 4.33272C9.85918 4.52462 10 4.86659 10 5.5C10 5.77614 10.2239 6 10.5 6C10.7761 6 11 5.77614 11 5.5C11 4.86659 11.1408 4.52462 11.3327 4.33272C11.5246 4.14082 11.8666 4 12.5 4C12.7761 4 13 3.77614 13 3.5C13 3.22386 12.7761 3 12.5 3C11.8666 3 11.5246 2.85918 11.3327 2.66728C11.1408 2.47538 11 2.13341 11 1.5Z"
							fill="currentColor"
						/>
						<path
							fill-rule="evenodd"
							clip-rule="evenodd"
							d="M20 15C15.1389 15 13 17.1389 13 22C13 17.1389 10.8611 15 6 15C10.8611 15 13 12.8611 13 8C13 12.8611 15.1389 15 20 15Z"
							stroke="currentColor"
							stroke-width="2"
							stroke-linejoin="round"
						/>
					</svg>
					<span> Connect to ChatGPT </span>
				</button>
				<InputButtonChoice
					buttonClass="btn btn-sm btn-box"
					label="Remove tracker"
					@input="removeTracker"
				></InputButtonChoice>
			</div>
		</section>
		<section>
			<h3>Brand statistics</h3>
			<template v-if="brand.tracker.status === 'ACTIVE'">
				<div class="c-brands-insight__duration">
					<span @click="setDuration(0)" :class="[{ active: days === 0 }]">
						Lifetime
					</span>
					<span @click="setDuration(7)" :class="[{ active: days === 7 }]">
						7 Days
					</span>
					<span @click="setDuration(30)" :class="[{ active: days === 30 }]">
						30 Days
					</span>
				</div>
				<template v-if="currentInsight">
					<Stats :insight="currentInsight"></Stats>
					<Breakdown :insight="currentInsight"></Breakdown>
					<Timeline :insight="currentInsight" :days="days"></Timeline>
					<Links :insight="currentInsight"></Links>
					<Words :insight="currentInsight"></Words>
					<Networks :insight="currentInsight"></Networks>
				</template>
				<blockquote v-else>
					<p>
						Insights haven't been calculated for this brand yet. They will be
						calculated automatically when the tracker scrapes a few ads.
					</p>
				</blockquote>
			</template>
			<template v-else>
				<blockquote>
					<p>This tracker is inactive.</p>
					<p>
						Trackers become inactive if your account has been deactivated or you
						have reached over the limit of your allowed trackers.
					</p>
				</blockquote>
			</template>
		</section>
		<Modal
			v-model="connectGuideOpen"
			:closable="true"
			class="c-brands-insight__connect-modal"
		>
			<template v-slot:title>
				<h2>Connect Swipekit to your chat app</h2>
			</template>
			<McpConnectGuide></McpConnectGuide>
			<McpToolList :collapsed="true"></McpToolList>
		</Modal>
	</div>
</template>

<script>
import Stats from './stats';
import Breakdown from './breakdown';
import Links from './links';
import Words from './words';
import Networks from './networks';
import Timeline from './timeline';

import InputButtonChoice from '@swipekit/components/form/input-button-choice';
import Modal from '@swipekit/components/modal';
import McpConnectGuide from '@swipekit/components/mcp/connect-guide.vue';
import McpToolList from '@swipekit/components/mcp/tool-list.vue';

export default {
	components: {
		Stats,
		Breakdown,
		Links,
		Words,
		Networks,
		Timeline,
		InputButtonChoice,
		Modal,
		McpConnectGuide,
		McpToolList,
	},

	props: {
		brand: {},
	},

	data: function () {
		return {
			days: 0,
			processing: false,
			connectGuideOpen: false,
		};
	},

	computed: {
		fbadlibrarylink: function () {
			return `https://www.facebook.com/ads/library?active_status=active&ad_type=all&country=ALL&media_type=all&search_type=page&view_all_page_id=${this.brand.fbId}`;
		},
		lifetimeInsight: function () {
			if (!this.brand.insight) {
				return;
			}
			return this.brand.insight.lifetime;
		},
		currentInsight: function () {
			if (!this.brand.insight) {
				return;
			}
			if (!this.days) {
				return this.brand.insight.lifetime;
			}
			if (this.days === 7) {
				return this.brand.insight['7days'];
			}
			if (this.days === 30) {
				return this.brand.insight['30days'];
			}
		},
		assetUrl: function () {
			return this.$store.getters['config/assetUrl'];
		},
	},

	methods: {
		async removeTracker() {
			this.processing = true;
			this.$store.dispatch('message/onTrackerRemoved');
			await this.$store.dispatch('brands/removeTracker', this.brand.tracker.id);

			window.location.href = `/brands`;
		},
		setDuration: function (days) {
			if (!days) {
				this.days = 0;
			} else {
				this.days = days;
			}
		},
	},
};
</script>

<style lang="scss">
.c-brands-insight {
	position: relative;
	background-color: var(--color-bg-1);
	width: calc(var(--header-width) + 360px);
	margin: var(--spacer-sm) auto;

	box-shadow: rgba(0, 0, 0, 0) 0px 0px 0px 0px, rgba(0, 0, 0, 0) 0px 0px 0px 0px,
		rgba(9, 9, 11, 0.08) 0px 0px 0px 1px, rgba(9, 9, 11, 0.08) 0px 1px 2px -1px,
		rgba(9, 9, 11, 0.04) 0px 2px 4px 0px;
	border-radius: 16px;

	&.processing {
		opacity: 0.75;
		pointer-events: none;
	}

	&__buttons {
		position: absolute;
		top: 14px;
		right: var(--margin-lg);
		display: flex;
		flex-direction: column;

		a {
			&:last-child {
				margin-top: var(--margin);
			}
		}
	}

	&__duration {
		display: inline-block;
		border: rgba(9, 9, 11, 0.1) solid 1px;
		border-radius: 8px;
		padding: 4px;

		span {
			display: inline-block;
			padding: var(--margin) var(--margin-lg);
			border-radius: 4px;
			font-size: var(--font-size-sm);
			line-height: 1;
			user-select: none;
			cursor: pointer;
			font-feature-settings: 'case' 0, 'dlig' 0, 'frac' 0, 'dnom' 0, 'numr' 0,
				'subs' 0, 'sups' 0, 'tnum', 'zero' 0, 'ss01', 'ss02' 0, 'ss03' 0, 'ss04',
				'ss05' 0, 'ss06' 0, 'ss07' 0, 'ss08' 0, 'cv01' 0, 'cv02' 0, 'cv03' 0,
				'cv04' 0, 'cv05' 0, 'cv06' 0, 'cv07' 0, 'cv08' 0, 'cv09' 0, 'cv10' 0,
				'cv11' 0, 'cv12' 0, 'cv13' 0, 'cpsp' 0, 'c2sc' 0, 'salt' 0, 'aalt' 0,
				'calt', 'ccmp', 'locl', 'kern';

			&.active {
				background-color: var(--color-primary);
				color: #fff;
			}

			&:hover {
				&:not(.active) {
					background-color: var(--color-primary-light);
				}
			}
		}
	}

	&__control {
		padding-top: var(--margin-lg);
		display: flex;
		flex-wrap: wrap;
		gap: var(--margin);

		a {
			height: 32px;
		}

		.c-input-button-choice {
			display: inline-block;

			.btn {
				min-height: 32px;
			}
		}
	}

	section {
		padding: var(--spacer-sm);

		&:not(:last-of-type) {
			border-bottom: rgba(9, 9, 11, 0.1) solid 1px;
		}
	}

	header {
		display: grid;
		grid-template-columns: 64px 1fr;
		grid-column-gap: var(--spacer-sm);
		align-items: center;

		img {
			width: 64px;
			height: 64px;
			background-color: cyan;
			border-radius: 100%;
			overflow: hidden;
			object-fit: cover;
		}

		h3 {
			display: inline-block;
			margin-bottom: 0.25rem;
		}

		p {
			margin: 0;
			display: flex;
			align-items: center;
			color: var(--color-font-light);
			font-weight: 500;

			a {
				margin-left: var(--margin);
			}
		}
	}

	blockquote {
		padding: var(--spacer-sm);
		background-color: var(--color-bg-3);
		border-radius: var(--border-radius);

		p:last-of-type {
			margin-bottom: 0;
		}
	}

	h3 {
		font-family: var(--font-family);
	}

	@container (max-width: 1240px) {
		width: calc(100% - var(--margin-lg) * 2);
	}

	@container (max-width:980px) {
		&__control {
			flex-direction: column;

			a,
			button {
				width: 100%;
			}
		}
	}
}

.vfm.c-brands-insight__connect-modal .modal-content {
	margin-top: 0;
	max-height: calc(100vh - 40px);
	max-height: calc(100dvh - 40px);
	overflow-y: auto;
}
</style>
